import {endpoints} from "../../../utils2";
import {fetchWrapper} from "../../../_services/fetch";

export function getAudioFile(userId, targetId, token, filename) {

    return fetchWrapper.getFile(endpoints.announcement.stream(userId, targetId), token.jwt)
        .then(response => {
            const contentType = response.headers.get('Content-Type');

            if (response.ok && contentType && contentType.startsWith('audio/')) {
                return response.blob().then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(link.href);
                });
            } else if (response.status === 404) {
                throw new Error('Invalid announcement id.');
            } else {
                throw new Error('Cannot fetch announcement. Try later.');
            }
        })
    // .catch(handleErrorInt)
    // .finally(() => setLoadingValue(false))
}